import { respondToExternalCalendarEvent as _respondToExternalCalendarEvent } from '@griply/services';
import {
  CalendarEventWriteResult,
  RespondToCalendarEventInput,
} from '@griply/types';
import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getFunctions } from './helpers';

export const respondToExternalCalendarEvent = async (
  payload: RespondToCalendarEventInput,
): Promise<CalendarEventWriteResult> => {
  try {
    return await _respondToExternalCalendarEvent({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error: unknown) {
    getErrorReporter().captureException(error, {
      tags: { source: 'external-calendars-respond-to-event' },
    });
    throw error;
  }
};
